import API, { CartItem, CartResponse } from "../api"
import GA4Utils from "../ga4"

export default class CartPage {

	private static QUANTITY_NOT_INTEGER = 'Quantity must be an integer.'
	private static QUANTITY_TOO_HIGH = 'Quantity must be less than 100.'
	private static TIME_TO_SAVE_AFTER_INPUT = 2000 // milliseconds
	private static timeout

	static isDevEnvironment: boolean = false
	static isBMSMPromoActive: boolean = false
	static siteName: string
	static siteDomainName: string
	static promoStart: string
	static promoEnd: string

	static promoProps: {
		promoType: "BMSM" | "GWP" | "BOGO" | "FS" | "pointsGwp"
		total?: number
		subTotal?: number
		discount?: number
		newTotal?: number
		active?: boolean
		promoTiers?: {
			minTotal: number
			dollarOff: number
		}[]
		freeGiftRemarkCopy?: string
		bogoPairs?: {
			mainSku: string
			subSku: string
			gwpSku: string
		}[]
		gwpProps?: {
			sku: string
			name: string
			qty: number
			listPrice: number
			listPoints: number
			imgPath: string
			hasGwpInCart: boolean
			bannerCopy: string
		}
	}

	static loading: boolean = false

	static onPageLoad() {
		CartPage.bindElementHandlers()
		CartPage.checkHTML()
	}

	static bindElementHandlers() {

		const checkoutButton = document.getElementById('btn_cart_checkout')
		const checkoutButtonIsButton = checkoutButton && checkoutButton.nodeName === 'BUTTON'
		const checkoutButtonNeedsOnClickEvent = checkoutButtonIsButton && !checkoutButton.onclick

		// Increment/decrement quantity buttons
		$('.qtyBtn.left, .qtyBtn.right').on('click', (e) => {

			const cartItemElem = e.target.closest('ul.cart-item') as HTMLUListElement

			const itemPosition = Number.parseInt(cartItemElem.dataset.position)
			const basketId = cartItemElem.dataset.basketid
			const price = Number.parseFloat(cartItemElem.dataset.price)
			const pricePoints = Number.parseInt(cartItemElem.dataset.pricepoints)

			const quantityInput = cartItemElem.querySelector('input[name="quantity"]') as HTMLInputElement

			const oldValue = Number.parseInt(quantityInput.value)
			let operation = e.target.dataset.operation as ('increment' | 'decrement')

			let newValue = oldValue

			if (operation === 'increment') {

				newValue = oldValue + 1

				if (newValue > 99) {
					alert(CartPage.QUANTITY_TOO_HIGH)
					newValue = 99
				}

			} else if (operation === 'decrement') {

				newValue = oldValue - 1

				if (newValue < 0) {
					newValue = 0
				}
			}

			if (newValue !== oldValue) {

				// If it's deleting the item...
				if (newValue <= 0) {
					CartPage.onClickDeleteProduct({
						basketId: basketId,
						itemPosition: itemPosition,
						oldValue: oldValue.toString(),
					})
				}

				// If it's updating the item quantity...
				else {
					CartPage.onUpdateQuantity({
						itemPosition: itemPosition,
						oldValue: oldValue,
						newValue: newValue,
						price: price,
						pricePoints: pricePoints,
					})
				}
			}
		})

		// Quantity input (on focus, save the old value)
		$('.quantity-input').on('focus', (e) => {
			const quantityInput = e.target as HTMLInputElement
			const value = Number.parseInt(quantityInput.value)
			quantityInput.dataset.oldvalue = value > 99
				? '99'
				: value < 1
					? '1'
					: value.toString()
		})

		// Quantity input (on focus out, restore last valid value if needed)
		$('.quantity-input').on('focusout', (e) => {
			const quantityInput = e.target as HTMLInputElement
			const floatValue = Number.parseFloat((e.target as HTMLInputElement).value)
			const oldValue = Number.parseInt(quantityInput.dataset.oldvalue)

			// The condition below should match the 'input' event condition
			if (isNaN(floatValue) || !Number.isInteger(floatValue)) {
				alert(CartPage.QUANTITY_NOT_INTEGER)
				quantityInput.value = oldValue.toString()
			}
		})

		// Quantity input
		$('.quantity-input').on('input', (e) => {

			const unorderedListElem = e.target.closest('ul.cart-item') as HTMLUListElement
			const itemPosition = Number.parseInt(unorderedListElem.dataset.position)

			// Disable the other inputs
			document.querySelectorAll('.quantity-input').forEach((elem: HTMLInputElement) => {
				if (elem !== e.target) {
					elem.readOnly = true
				}
			})

			// Disable increment/decrement buttons
			document.querySelectorAll('.qtyBtn').forEach((elem: HTMLButtonElement) => {
				elem.disabled = true
			})

			// Disable delete buttons
			document.querySelectorAll('.delete').forEach((elem: HTMLButtonElement) => {
				elem.disabled = true
			})

			clearTimeout(CartPage.timeout)

			CartPage.timeout = setTimeout(() => {

				const quantityInput = e.target as HTMLInputElement
				const floatValue = Number.parseFloat((e.target as HTMLInputElement).value)
				let newValue = Number.parseInt((e.target as HTMLInputElement).value)

				CartPage.log(`[input] floatValue ${floatValue}`)
				CartPage.log(`[input] newValue ${newValue}`)

				// The condition below should match the 'focusout' event condition
				if (isNaN(floatValue) || !Number.isInteger(floatValue)) {

					// Enable the other inputs
					document.querySelectorAll('.quantity-input').forEach((elem: HTMLInputElement) => {
						if (elem !== e.target) {
							elem.readOnly = false
						}
					})

					// Enable increment/decrement buttons
					document.querySelectorAll('.qtyBtn').forEach((elem: HTMLButtonElement) => {
						elem.disabled = false
					})

					// Enable delete buttons
					document.querySelectorAll('.delete').forEach((elem: HTMLButtonElement) => {
						elem.disabled = false
					})

					return
				}

				const basketId = unorderedListElem.dataset.basketid
				const price = Number.parseFloat(unorderedListElem.dataset.price)
				const pricePoints = Number.parseInt(unorderedListElem.dataset.pricepoints)
				const oldValue = Number.parseInt(quantityInput.dataset.oldvalue)

				if (newValue < 0) {
					newValue = 0
				}

				if (newValue > 99) {
					alert(CartPage.QUANTITY_TOO_HIGH)
					newValue = 99
				}

				if (newValue !== oldValue) {

					// If it's deleting the item...
					if (newValue <= 0) {
						CartPage.onClickDeleteProduct({
							basketId: basketId,
							itemPosition: itemPosition,
							oldValue: oldValue.toString(),
						})
					}

					// If it's updating the item quantity...
					else {
						CartPage.onUpdateQuantity({
							itemPosition: itemPosition,
							oldValue: oldValue,
							newValue: newValue,
							price: price,
							pricePoints: pricePoints,
						})
					}
				} else {

					// Enable the other inputs
					document.querySelectorAll('.quantity-input').forEach((elem: HTMLInputElement) => {
						if (elem !== e.target) {
							elem.readOnly = false
						}
					})

					// Enable increment/decrement buttons
					document.querySelectorAll('.qtyBtn').forEach((elem: HTMLButtonElement) => {
						elem.disabled = false
					})

					// Enable delete buttons
					document.querySelectorAll('.delete').forEach((elem: HTMLButtonElement) => {
						elem.disabled = false
					})
				}

			}, CartPage.TIME_TO_SAVE_AFTER_INPUT)
		})

		// Delete button
		$('.delete').on('click', (e) => {

			const unorderedListElem = e.target.closest('ul.cart-item') as HTMLUListElement
			const itemPosition = Number.parseInt(unorderedListElem.dataset.position)
			const basketId = unorderedListElem.dataset.basketid
			const quantityInput = unorderedListElem.querySelector('input[name="quantity"]') as HTMLInputElement
			const oldValue = quantityInput.value

			CartPage.onClickDeleteProduct({
				basketId: basketId,
				itemPosition: itemPosition,
				oldValue: oldValue
			})
		})

		// Undo button
		$('.undo').on('click', (e) => {

			const unorderedListElem = e.target.closest('ul.cart-item') as HTMLUListElement
			const itemPosition = Number.parseInt(unorderedListElem.dataset.position)
			const oldBasketId = unorderedListElem.dataset.oldbasketid
			const itemId = unorderedListElem.dataset.itemid
			const invtId = unorderedListElem.dataset.invtid
			const price = Number.parseFloat(unorderedListElem.dataset.price)
			const pricePoints = Number.parseInt(unorderedListElem.dataset.pricepoints)
			const extensionsGroups = unorderedListElem.dataset.extensiongroups
			const extensions = unorderedListElem.dataset.selectedextensions

			CartPage.onClickUndoRemoval({
				oldBasketId: oldBasketId,
				itemPosition: itemPosition,
				itemId: itemId,
				invtId: invtId,
				price: price,
				pricePoints: pricePoints,
				extensionsGroups: extensionsGroups,
				extensions: extensions
			})
		})

		// Checkout button
		if (checkoutButtonIsButton && checkoutButtonNeedsOnClickEvent) {
			$(checkoutButton).on('click', (e) => {
				window.location.href = 'checkout.aspx'
			})
		}
	}

	static async onUpdateQuantity({
		itemPosition,
		newValue,
		oldValue,
		price,
		pricePoints
	}: {
		itemPosition: number
		newValue: number
		oldValue: number
		price: number
		pricePoints: number
	}) {

		if (CartPage.loading) {
			return
		}

		CartPage.log(`[onUpdateQuantity] itemPosition ${itemPosition}`)
		CartPage.log(`[onUpdateQuantity] newValue ${newValue}`)
		CartPage.log(`[onUpdateQuantity] oldValue ${oldValue}`)
		CartPage.log(`[onUpdateQuantity] price ${price}`)
		CartPage.log(`[onUpdateQuantity] pricePoints ${pricePoints}`)

		const formData = new FormData(document.getElementById('OCForm1') as HTMLFormElement)

		const viewState = encodeURIComponent(API.viewState || formData.get('__VIEWSTATE') as string)
		const viewStateGenerator = encodeURIComponent(formData.get('__VIEWSTATEGENERATOR') as string)
		const viewStateEncrypted = encodeURIComponent(formData.get('__VIEWSTATEENCRYPTED') as string)

        const cartItemElem = document.getElementById(`item-${itemPosition}`) as HTMLUListElement ||
            document.getElementById(`cart-item-${itemPosition}`) as HTMLUListElement

		const quantityInput = cartItemElem.querySelector('input[name="quantity"]') as HTMLInputElement

		const basketIds = Array.from(formData.getAll('basketID')) as string[]
		const productIds = Array.from(formData.getAll('productID')) as string[]
		const quantities = Array.from(formData.getAll('quantity')) as string[]

		const cartItems: {
			basketId: string
			productId: string
			quantity: number
		}[] = []

		CartPage.log(`[onUpdateQuantity] Building the cart items array...`)

		// Build the cartItems array
		for (let i = 0; i < basketIds.length; i++) {
			const basketId = basketIds[i]
			const productId = productIds[i]
			const quantity = quantities[i]

			CartPage.log(`[onUpdateQuantity] (${i + 1}) basketId ${basketId}`)
			CartPage.log(`[onUpdateQuantity] (${i + 1}) productId ${productId}`)
			CartPage.log(`[onUpdateQuantity] (${i + 1}) quantity ${quantity}`)

			// If it's the clicked item, update the quantity
			if (i === itemPosition - 1) {

				CartPage.updateItemQuantity(itemPosition, newValue.toString())

				cartItems.push({
					basketId: basketId,
					productId: productId,
					quantity: newValue
				})
			}

			// If it's not the clicked item, keep the same quantity
			else {
				cartItems.push({
					basketId: basketId,
					productId: productId,
					quantity: Number.parseInt(quantity)
				})
			}
		}

		CartPage.toggleLoading(itemPosition)

		let result: CartResponse

		try {
			result = await API.updateCartQuantities({
				viewState: viewState,
				viewStateGenerator: viewStateGenerator,
				viewStateEncrypted: viewStateEncrypted,
				cartItems: cartItems
			})
		} catch (err) {
			console.error(err)
			CartPage.updateItemQuantity(itemPosition, oldValue.toString())
		} finally {
			CartPage.toggleLoading(itemPosition)
		}

		if (!result) {
			CartPage.updateItemQuantity(itemPosition, oldValue.toString())
			console.error('[onClickUpdateQuantity] Failed to update cart quantities.')
			return
		}

		quantityInput.dataset.oldvalue = newValue.toString()

		const currency = result.currency
		const subtotal = result.subtotal
		const subtotalPoints = result.subtotalPoints
		const newCartItems = result.newCartItems

		CartPage.log(`[onClickUpdateQuantity] currency ${currency}`)
		CartPage.log(`[onClickUpdateQuantity] subtotal ${subtotal}`)
		CartPage.log(`[onClickUpdateQuantity] subtotalPoints ${subtotalPoints}`)
		CartPage.log(`[onClickUpdateQuantity] newCartItems`, newCartItems)

		const currencySymbol = '$'

		CartPage.updateItemTotal({
			itemPosition: itemPosition,
			quantity: newValue,
			price: price,
			pricePoints: pricePoints,
			currency: currencySymbol
		})

		CartPage.updateCartTotals({
			subtotal: subtotal,
			subtotalPoints: subtotalPoints,
			currency: currencySymbol
		})

		CartPage.saveCartInSalesforce(newCartItems)

		// If one or more items were added to the cart in another tab/page...
		if (newCartItems.length > cartItems.length) {

			// Reload the page
			document.location.reload()
		}
	}

	static async onClickDeleteProduct({
		basketId,
		itemPosition,
		oldValue
	}: {
		basketId: string
		itemPosition: number
		oldValue: string
	}) {

		if (CartPage.loading) {
			return
		}

		CartPage.log(`[onClickDeleteProduct] Removing product from cart...`)
		CartPage.log(`[onClickDeleteProduct] basketId: ${basketId}`)
		CartPage.log(`[onClickDeleteProduct] itemPosition: ${itemPosition}`)
		CartPage.log(`[onClickDeleteProduct] oldValue: ${oldValue}`)

		const cartItemElem = document.getElementById(`item-${itemPosition}`) as HTMLUListElement ||
            document.getElementById(`cart-item-${itemPosition}`) as HTMLUListElement

		const cartItemElemInHeader = document.getElementById(`modal-item-${itemPosition}`)
		const quantityInput = cartItemElem.querySelector('input[name="quantity"]') as HTMLInputElement

		CartPage.toggleLoading(itemPosition)
		CartPage.updateItemQuantity(itemPosition, '0')

		let result: CartResponse

		try {
			result = await API.deleteItemFromCart({
				basketId: basketId,
			})
		} catch (err) {
			console.error(err)
			CartPage.updateItemQuantity(itemPosition, oldValue)
		} finally {
			CartPage.toggleLoading(itemPosition)
		}

		if (!result) {
			console.error('Failed to delete product from cart.')
			return
		}

		const subtotal = result.subtotal
		const subtotalPoints = result.subtotalPoints
		const newCartItems = result.newCartItems

		CartPage.log(`[onClickDeleteProduct] Removed product from cart!`)

		CartPage.updateCartTotals({
			subtotal: subtotal,
			subtotalPoints: subtotalPoints,
			currency: '$'
		})

		// Add class "deleted" to UL
		cartItemElem.classList.add('deleted')
		cartItemElemInHeader.classList.add('deleted')

		// Remove the data-basketid property from the element (this basketid is no longer valid since the product was removed)
		document.querySelector(`[value="${basketId}"]`).setAttribute('value', '')
		document.querySelectorAll(`[data-basketid="${basketId}"]`).forEach((elem) => {
			elem.setAttribute('data-oldbasketid', basketId)
			elem.removeAttribute('data-basketid')
		})

		// Get remaining basket ids
		const basketIds = Array.from(document.querySelectorAll('input[name="basketID"]'))
			.map((elem) => elem.getAttribute('value'))
			.filter((basketId) => basketId !== '')

		// Remove GWP Item if it exists and is the only one on cart
		if (CartPage.promoProps && CartPage.promoProps.promoType === 'GWP') {
			if (basketIds.length === 1) {
				const shoppingCart = document.querySelector('#cart-items-container')
				const item = shoppingCart?.querySelector(`[data-basketid="${basketIds[0]}"]`)
				if (item) {
					const itemId = item.getAttribute('data-itemid')
					if (itemId?.includes('-GWP')) {
						const deleteButton = item.querySelector('button.delete') as HTMLButtonElement
						if (deleteButton) {
							deleteButton.click()
							const undoButton = item.querySelector('button.undo') as HTMLButtonElement
							if (undoButton) {
								undoButton.style.display = 'none' // Hide the undo button
								undoButton.disabled = true // Disable the undo button
							}
						}
					}
				}
			}
		}

		// If the cart is empty...
		if (basketIds.length === 0) {
			document.getElementById('DIVNoItem').style.display = 'unset'
			document.getElementById('DIVcartSumItemsList').style.display = 'none'
			document.getElementById('DIVcartbtns').style.display = 'none'
		}

		const oldQuantity = quantityInput.dataset.oldvalue

		const ga4Items = (window as any).GA4Items

		// Update ga4Items array with new basket id
		ga4Items[basketId] = {
			...ga4Items[basketId],
			quantity: Number.parseInt(oldQuantity)
		}

		const ga4Item = ga4Items[basketId]

		if (ga4Item) {
			GA4Utils.trackRemoveFromCartEvent([ga4Item])
		} else {
			console.error(`[onClickDeleteProduct] GA4 item not found for basketId ${basketId}.`)
		}

		CartPage.saveCartInSalesforce(newCartItems)

		const oldCartItemsCount = document.querySelectorAll('#cart-items-container ul.cart-item').length

		// If one or more items were added to the cart in another tab/page...
		if (newCartItems.length > oldCartItemsCount) {

			// Reload the page
			document.location.reload()
		}
	}

	static async onClickUndoRemoval({
		oldBasketId,
		itemPosition,
		itemId,
		invtId,
		price,
		pricePoints,
		extensionsGroups,
		extensions
	}: {
		oldBasketId: string
		itemPosition: number
		itemId: string
		invtId: string
		price: number
		pricePoints: number
		extensionsGroups: string
		extensions: string
	}) {

		if (CartPage.loading) {
			return
		}

		CartPage.log(`[onClickUndoRemoval] Adding product back to cart...`)
		CartPage.log(`[onClickUndoRemoval] oldBasketId: ${oldBasketId}`)
		CartPage.log(`[onClickUndoRemoval] itemPosition: ${itemPosition}`)
		CartPage.log(`[onClickUndoRemoval] itemId: ${itemId}`)
		CartPage.log(`[onClickUndoRemoval] invtId: ${invtId}`)
		CartPage.log(`[onClickUndoRemoval] price: ${price}`)
		CartPage.log(`[onClickUndoRemoval] extensionsGroups: ${extensionsGroups}`)
		CartPage.log(`[onClickUndoRemoval] extensions: ${extensions}`)

		const cartItemElem = document.getElementById(`item-${itemPosition}`) as HTMLUListElement ||
            document.getElementById(`cart-item-${itemPosition}`) as HTMLUListElement

		const quantityInput = cartItemElem.querySelector(`input[name="quantity"]`) as HTMLInputElement

		const extensionsSplited = (extensions || '').split(';')
		const extensionsArray = extensionsSplited[0] !== '' ? extensionsSplited : []

		const oldQuantity = quantityInput.dataset.oldvalue

		CartPage.toggleLoading(itemPosition)

		CartPage.toggleDeleted(itemPosition)

		CartPage.updateItemQuantity(itemPosition, oldQuantity)

		let result: CartResponse

		try {
			result = await API.addOneItemToCart({
				itemId: itemId,
				extensionsGroups: extensionsGroups,
				extensions: extensionsArray,
				quantity: oldQuantity
			})
		} catch (err) {
			console.error(err)
			CartPage.toggleDeleted(itemPosition)
			CartPage.updateItemQuantity(itemPosition, '0')
		} finally {
			CartPage.toggleLoading(itemPosition)
		}

		const basketIds = result.basketIds
		const subtotal = result.subtotal
		const subtotalPoints = result.subtotalPoints
		const newCartItems = result.newCartItems

		CartPage.log(`[onClickUndoRemoval] newCartItems`, newCartItems)

		// Find the index of the added item
		const addedItemIndex = newCartItems.findIndex(elem => elem.invtId === invtId)

		// Get the new basket id
		const basketId = basketIds[addedItemIndex]

		if (!basketIds || !subtotal || !subtotalPoints) {
			console.error(`[onClickUndoRemoval] Something went wrong adding item back to cart.`)
			console.error(`[onClickUndoRemoval] basketId: ${basketId}`)
			console.error(`[onClickUndoRemoval] subtotal: ${subtotal}`)
			console.error(`[onClickUndoRemoval] subtotalPoints: ${subtotalPoints}`)
			return
		}

		CartPage.log(`[onClickUndoRemoval] Added product back to cart!`)
		CartPage.log(`[onClickUndoRemoval] newCartItems.length ${newCartItems.length}`)
		CartPage.log(`[onClickUndoRemoval] basketId: ${basketId}`)

		CartPage.updateItemTotal({
			itemPosition: itemPosition,
			quantity: Number.parseInt(oldQuantity),
			price: price,
			pricePoints: pricePoints,
			currency: '$'
		})

		CartPage.updateCartTotals({
			subtotal: subtotal,
			subtotalPoints:
				subtotalPoints,
			currency: '$'
		})

		// Add the basket id to the input
		document.querySelectorAll('input[name="basketID"]')[itemPosition - 1].setAttribute('value', basketId)

		// Removed the old basket id (not needed anymore) and assign the new basket id
		document.querySelectorAll(`[data-oldbasketid="${oldBasketId}"`).forEach((elem) => {
			elem.removeAttribute('data-oldbasketid')
			elem.setAttribute('data-basketid', basketId)
		})

		// Toggle items visibility in header cart dropdown
		if (document.getElementById('DIVNoItem').style.display) {
			document.getElementById('DIVNoItem').style.display = 'none'
			document.getElementById('DIVcartSumItemsList').style.display = 'unset'
			document.getElementById('DIVcartbtns').style.display = 'unset'
		}

		const ga4Items = (window as any).GA4Items

		// Update ga4Items array with new basket id
		ga4Items[basketId] = {
			...ga4Items[oldBasketId],
			quantity: Number.parseInt(oldQuantity)
		}

		// Delete the old basket id from the ga4Items array
		delete ga4Items[oldBasketId]

		// Track the add_to_cart event
		const ga4Item = ga4Items[basketId]
		GA4Utils.trackAddToCartEvent([ga4Item], {
            id: ga4Item.item_id,
            name: ga4Item.item_name,
            category: ga4Item.item_category,
            value: ga4Item.price * ga4Item.quantity
        })

		CartPage.saveCartInSalesforce(newCartItems)

		const oldCartItemsCount = document.querySelectorAll('#cart-items-container ul.cart-item').length

		// If one or more items were added to the cart in another tab/page...
		if (newCartItems.length > oldCartItemsCount) {

			// Reload the page
			document.location.reload()
		}
	}

	static toggleLoading(itemPosition: number | string) {

		const cartItemElem = document.getElementById(`item-${itemPosition}`) as HTMLUListElement ||
            document.getElementById(`cart-item-${itemPosition}`) as HTMLUListElement

		const cartItemElemInHeader = document.getElementById(`modal-item-${itemPosition}`)

		const checkoutButton = document.getElementById('btn_cart_checkout') as HTMLButtonElement | HTMLLinkElement
		const checkoutButtonInHeader = document.querySelector('#DIVcartbtns .btn-main') as HTMLLinkElement
			|| document.querySelector('#DIVcartbtns .btn-black') as HTMLLinkElement
		const viewBagButton = document.querySelector('#DIVcartbtns .btn-plain') as HTMLLinkElement
			|| document.querySelector('#DIVcartbtns .btn-plain') as HTMLLinkElement

		const checkoutButtonHref = (checkoutButton as HTMLLinkElement).href
		const checkoutButtonInHeaderHref = checkoutButtonInHeader.href
		const viewBagButtonHref = viewBagButton.href

		const checkoutButtonIsButton = checkoutButton && checkoutButton.nodeName === 'BUTTON'

		if (CartPage.loading) {
			CartPage.loading = false

			// Remove class "loading" from UL elements
			document.querySelectorAll('.cart-item').forEach((elem) => elem.classList.remove('loading'))
			document.querySelectorAll('.modal-cart-item').forEach((elem) => elem.classList.remove('loading'))

			// Enable buttons
			if (checkoutButtonIsButton) {
				checkoutButton.removeAttribute('disabled')
			} else {
				checkoutButton.setAttribute('href', checkoutButtonHref)
			}
			checkoutButtonInHeader.setAttribute('href', checkoutButtonInHeaderHref)
			viewBagButton.setAttribute('href', viewBagButtonHref)

			// Enable quantity inputs
			document.querySelectorAll('.quantity-input').forEach((elem: HTMLInputElement) => {
				elem.readOnly = false
			})

			// Enable increment/decrement buttons
			document.querySelectorAll('.qtyBtn').forEach((elem: HTMLButtonElement) => {
				elem.disabled = false
			})

			// Enable delete buttons
			document.querySelectorAll('.delete').forEach((elem: HTMLButtonElement) => {
				elem.disabled = false
			})

		} else {
			CartPage.loading = true

			// Add class "loading" to UL
			cartItemElem.classList.add('loading')
			cartItemElemInHeader.classList.add('loading')

			// Disable buttons
			if (checkoutButtonIsButton) {
				checkoutButton.setAttribute('disabled', 'true')
			} else {
				checkoutButton.removeAttribute('href')
			}
			checkoutButtonInHeader.removeAttribute('href')
			viewBagButton.removeAttribute('href')

			// Disable quantity inputs
			document.querySelectorAll('.quantity-input').forEach((elem: HTMLInputElement) => {
				elem.readOnly = true
			})

			// Disable increment/decrement buttons
			document.querySelectorAll('.qtyBtn').forEach((elem: HTMLButtonElement) => {
				elem.disabled = true
			})

			// Disable delete buttons
			document.querySelectorAll('.delete').forEach((elem: HTMLButtonElement) => {
				elem.disabled = true
			})
		}
	}

	static toggleDeleted(itemPosition: number | string) {

		const cartItemElem = document.getElementById(`item-${itemPosition}`) as HTMLUListElement ||
            document.getElementById(`cart-item-${itemPosition}`) as HTMLUListElement

		const cartItemElemInHeader = document.getElementById(`modal-item-${itemPosition}`)

		cartItemElem.classList.toggle('deleted')
		cartItemElemInHeader.classList.toggle('deleted')
	}

	static updateItemQuantity(itemPosition: number, newValue: string) {
		const cartItemElem = document.getElementById(`item-${itemPosition}`) as HTMLUListElement ||
            document.getElementById(`cart-item-${itemPosition}`) as HTMLUListElement

		const cartItemElemInHeader = document.getElementById(`modal-item-${itemPosition}`)

		const quantityInput = cartItemElem.querySelector(`input[name="quantity"]`) as HTMLInputElement
		const quantitySpanInHeader = cartItemElemInHeader.querySelector(`.Qty span`) as HTMLParagraphElement

		const bubbleCountSpanElem = document.getElementById('bubble-cnt') as HTMLSpanElement

		let newBubbleCount = 0

		// Update the quantity in the quantity input
		quantityInput.setAttribute('value', newValue)
		quantityInput.value = newValue

		// Update the quantity in the span in the header
		quantitySpanInHeader.innerHTML = newValue

		// Calculate new total count
		document.querySelectorAll('.quantity-input').forEach((elem: HTMLInputElement) => {
			newBubbleCount += Number.parseInt(elem.value)
		})

		// Refresh bubble count element
		bubbleCountSpanElem.innerHTML = `${newBubbleCount}`
	}

	static updateItemTotal({
		itemPosition,
		quantity,
		price,
		pricePoints,
		currency
	}: {
		itemPosition: number,
		quantity: number,
		price: number,
		pricePoints: number,
		currency: '$'
	}) {

		const cartItemElem = document.getElementById(`item-${itemPosition}`) as HTMLUListElement ||
            document.getElementById(`cart-item-${itemPosition}`) as HTMLUListElement

		const totalElem = cartItemElem.querySelector('.Total.price-cash span') as HTMLParagraphElement
		const totalPointsElem = cartItemElem.querySelector('.Total.price-points span') as HTMLParagraphElement

		totalElem.innerHTML = `${currency || ''}${Number.parseFloat((quantity * price).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`

		if (totalPointsElem) {
			totalPointsElem.innerHTML = `${(quantity * pricePoints).toLocaleString('en-US')} Points`
		}
	}

	static updateCartTotals({
		subtotal,
		subtotalPoints,
		currency = '$'
	}: {
		subtotal: string,
		subtotalPoints: string,
		currency: '$'
	}) {

		// Elements used when there is no discount
		const subtotalElem = document.getElementById('subtotalInUI')
		const subtotalHeaderElem = document.getElementById('hdCashSubtotal')
		const subtotalPointsElem = document.getElementById('subtotalPointsInUI')
		const subtotalPointsHeaderElem = document.getElementById('hdPointsSubtotal')

		// Elements used when there is discount
		const cartTotalElem = document.getElementById('carttotalInUI')
		const cartTotalHeaderElem = document.getElementById('hdCartTotal')
		const discountElem = document.getElementById('discountInUI')
		const discountHeaderElem = document.getElementById('hdDiscount')
		const totalElem = document.getElementById('totalInUI')
		const totalHeaderElem = document.getElementById('hdTotal')
		const cartPointsSubtotalElem = document.getElementById('cartPointsSubtotal')
		const cartPointsSubtotalHeaderElem = document.getElementById('hdPointsSubtotalDiscount')

		// Update the elements
		subtotalElem.innerHTML = `${currency || ''}${Number.parseFloat(subtotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || ''}`
		subtotalHeaderElem.innerHTML = `${currency || ''}${Number.parseFloat(subtotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || ''}`

		if (subtotalPointsElem) {
			subtotalPointsElem.innerHTML = subtotalPoints ? `${Number.parseInt(subtotalPoints).toLocaleString('en-US')} Points` : ''
		}

		if (subtotalPointsHeaderElem) {
			subtotalPointsHeaderElem.innerHTML = subtotalPoints ? `${Number.parseInt(subtotalPoints).toLocaleString('en-US')} Points` : ''
		}

		if (cartPointsSubtotalElem) {
			cartPointsSubtotalElem.innerHTML = subtotalPoints ? `${Number.parseInt(subtotalPoints).toLocaleString('en-US')} Points` : ''
		}

		if (cartPointsSubtotalHeaderElem) {
			cartPointsSubtotalHeaderElem.innerHTML = subtotalPoints ? `${Number.parseInt(subtotalPoints).toLocaleString('en-US')} Points` : ''
		}


		if (CartPage.isBMSMPromoActive) {

			// Calculate new discount for BMSM promo
			let newDiscount = CartPage.promoProps.discount || 0

			const subtotalNumber = Number.parseFloat(subtotal)

			let promoTiersLenght = CartPage.promoProps.promoTiers.length
			if (subtotalNumber < CartPage.promoProps.promoTiers[0].minTotal) {
				newDiscount = 0
			} else if (subtotalNumber > CartPage.promoProps.promoTiers[promoTiersLenght - 1].minTotal) {
				newDiscount = CartPage.promoProps.promoTiers[promoTiersLenght - 1].dollarOff
			} else {
				for (let i = 0; i < promoTiersLenght - 1; i++) {
					if ((subtotalNumber > CartPage.promoProps.promoTiers[i].minTotal) && (subtotalNumber < CartPage.promoProps.promoTiers[i + 1].minTotal)) {
						newDiscount = CartPage.promoProps.promoTiers[i].dollarOff
					}
				}
			}

			CartPage.promoProps.discount = newDiscount

			if (newDiscount > 0) {

				const cartTotalString = `${currency || ''}${Number.parseFloat(subtotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || ''}`

				const discountString = newDiscount > 0
					? `-${currency || ''}${newDiscount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
					: ''

				const totalString = `${currency || ''}${Number.parseFloat((subtotalNumber - newDiscount).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || ''}`

				// Update subtotals (with discount)
				cartTotalElem.innerHTML = cartTotalString
				cartTotalHeaderElem.innerHTML = cartTotalString
				discountElem.innerHTML = discountString
				discountHeaderElem.innerHTML = discountString
				totalElem.innerHTML = totalString
				totalHeaderElem.innerHTML = totalString

				// Hide totals without discount
				$('#cartULNoDiscount').hide()
				$('#hdULNoDiscount').hide()

				// Show totals with discount
				$('#cartULDiscount').show()
				$('#hdULDiscount').show()

			} else {

				// Hide totals with discount
				$('#cartULDiscount').hide()
				$('#hdULDiscount').hide()

				// Show totals without discount
				$('#cartULNoDiscount').show()
				$('#hdULNoDiscount').show()
			}
		}
	}

	static saveCartInSalesforce(cartItems: CartItem[]) {

		const SalesforceAbandonedCartUtils: SalesforceAbandonedCartUtils = ((window as any).SalesforceAbandonedCartUtils)

		if (!SalesforceAbandonedCartUtils) {
			console.error('SalesforceAbandonedCartUtils not found.')
			return
		}

		SalesforceAbandonedCartUtils.cartOrOrderData = cartItems.map((cartItem) => ({
			item: cartItem.itemId.trim(),
			quantity: cartItem.quantity,
			price: cartItem.listPrice,
			sale_price: (cartItem.salePrice < cartItem.listPrice)
				? cartItem.salePrice
				: undefined,
			unique_id: cartItem.alternateId
				? cartItem.alternateId
				: cartItem.invtId
					? cartItem.invtId
					: undefined
		}))

		SalesforceAbandonedCartUtils.trackCart()
	}

	static log(message: string, ...optionalParams: any[]) {
		if (CartPage.isDevEnvironment) {
			console.log(message, ...optionalParams)
		}
	}

	static checkHTML() {

		const cartIsEmpty = (document.querySelector('.empty-cart') !== null) ||
			(document.getElementById('DIVNoItem') !== null)

		if (cartIsEmpty) {
			// TODO: Check if empty cart HTML elements exist
			CartPage.log("[checkHTML] Cart is empty, won't check for HTML elements.")
			return
		}

		const requiredElementsIds = [
			'OCForm1',
			'DIVNoItem',
			'DIVcartSumItemsList',
			'DIVcartbtns',
			'btn_cart_checkout',
			'bubble-cnt',
			'subtotalInUI',
			'hdCashSubtotal',
			'carttotalInUI',
			'hdCartTotal',
			'discountInUI',
			'hdDiscount',
			'totalInUI',
			'hdTotal'
		]

		const optionalElementsIds = [
			'subtotalPointsInUI',
			'hdPointsSubtotal',
			'cartPointsSubtotal',
			'hdPointsSubtotalDiscount',
		]

		const requiredElementsSelectors = [
			'.Total.price-cash span',
		]

		const optionalElementsSelectors = [
			'.Total.price-points span',
		]

		for (const id of requiredElementsIds) {
			if (!document.getElementById(id)) {
				console.error(`Element "#${id}" not found.`)
			}
		}

		for (const selector of requiredElementsSelectors) {
			if (!document.querySelector(selector)) {
				console.error(`Element "${selector}" not found.`)
			}
		}

		for (const id of optionalElementsIds) {
			if (!document.getElementById(id)) {
				console.warn(`Element "#${id}" not found.`)
			}
		}

		for (const selector of optionalElementsSelectors) {
			if (!document.querySelector(selector)) {
				console.warn(`Element "${selector}" not found.`)
			}
		}
	}
}

interface SalesforceAbandonedCartUtils {

	clientEmail: string
	catalogId: string
	subscriberKey: string
	cartOrOrderData: any[]

	/**
	 * Defines if should log messages in the console.
	 */
	debug: boolean

	/**
	 * Should be called as soon as possible.
	 */
	setOrganizationId: (salesforceOrganizationId: string) => void

	/**
	 * Should be called as soon as possible.
	 */
	setCatalogId: (catalogId: string) => void

	/**
	 * Should be called after the client enters his email in:
	 * - The email subscription lightbox
	 * - The email subscription in the footer
	 * - The email subscription in the checkout page
	 */
	setClientEmail: (email: string) => void

	/**
	 * Should be called after `setCatalogId` and `setClientEmail`.
	 */
	setSubscriberKey: () => void

	/**
	 * Should be called for each new product added to the cart (after clicking "Add to cart").
	 */
	addCartOrOrderData: ({ item, quantity, price, salePrice, uniqueId }: {
		item: any
		quantity: any
		price: any
		salePrice?: any
		uniqueId: any
	}) => void

	/**
	 * Sends the cart data to Salesforce.
	 */
	trackCart: () => void

	/**
	 * Should be called if the order is completed by the client.
	 */
	trackConversion: () => void
}